import { useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Form, ShowInput, Img, StyledButtonConfirmar, StyledButtonVoltar, Label } from './styles.js'
import { appStatus } from '../../store/modules/app_status/actions.js'
import { userLogin } from '../../store/modules/login/actions.js';
import Logo from '../../assets/logo-vert-white.png';
import { useModalContext } from '../CustomModal/ModalProvider.jsx';
import { userService } from '../../services/userService.js';

const ChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showError, showSuccess } = useModalContext();
  const app_status = useSelector((state) => state.app_status.status);
  const [email, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showLoading, setShowLoading] = useState(false);
  const [loading, setLoading] = useState(false); // 👈 adicione esta linha
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [userId, setUserId] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get('user');
    if (userId) {
      setUserId(userId);
    }
  }, []);

  // ChangePassword.jsx (trecho relevante)
  const handleResetPassword = async (event) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      showError('As novas senhas não coincidem.');
      return;
    }

    console.log('1');

    setLoading(true);
    try {
      await userService.resetPasswordByEmail(email, currentPassword, newPassword);
      showSuccess('Senha alterada com sucesso! Faça login com sua nova senha.');
      console.log('2');
      navigate('/');
    } catch (error) {
      console.error('Erro:', error);
      console.log('3');
      const message = error.response?.data?.error || error.response?.data?.message || 'Erro ao alterar senha. Verifique seus dados.';
      showError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleComeBack = () => {
    navigate('/');
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.1 }}
      >
        <Container>
          {showLoading ? (
            <motion.div
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.1 }}
            >
              <h1 style={{ color: 'var(--text-heading)', fontFamily: 'Arial, Helvetica, sans-serif', fontWeight: '700', fontSize: '48px', letterSpacing: '0' }}>Bem Vindo!</h1>
            </motion.div>
          ) : (
            <>
              <div style={{ overflow: 'hidden' }}>
                <Img
                  src={Logo}
                  alt="Vert Ecotech"
                  style={{
                    filter: 'drop-shadow(3px 3px 1px rgba(255, 255, 255, 0.9))',
                    borderRadius: '10px'
                  }}
                />
              </div>

              <motion.div
                initial={{ opacity: 1 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0.5 }}
                transition={{ duration: 0.1 }}
              >
                <Form onSubmit={handleResetPassword}>
                  <Label>Email</Label>
                  <ShowInput
                    type="text"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={event => setUsername(event.target.value)}
                  />

                  <Label>Senha atual</Label>
                  <ShowInput
                    type="password"
                    placeholder="••••••••"
                    value={currentPassword}
                    onChange={event => setCurrentPassword(event.target.value)}
                  />

                  <Label>Nova senha</Label>
                  <ShowInput
                    type="password"
                    placeholder="••••••••"
                    value={newPassword}
                    onChange={event => setNewPassword(event.target.value)}
                  />

                  <Label>Confirmar nova senha</Label>
                  <ShowInput
                    type="password"
                    placeholder="••••••••"
                    value={confirmPassword}
                    onChange={event => setConfirmPassword(event.target.value)}
                  />

                  <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                    <StyledButtonConfirmar type="submit">
                      Alterar senha
                    </StyledButtonConfirmar>
                    <StyledButtonVoltar type="button" onClick={handleComeBack}>
                      Voltar
                    </StyledButtonVoltar>
                  </div>
                </Form>
              </motion.div>
            </>
          )}
        </Container>
      </motion.div>
    </>
  );
};

export default ChangePassword;